import { OnInit, Component } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { Router } from '@angular/router';
import { PasswordResetRequestViewModel } from '../viewmodels/reset-password-request-viewmodel';

@Component({
  selector: 'app-password-request-cmp',
  templateUrl: './password-request.component.html',
})
export class PasswordRequestComponent implements OnInit {
  enterLoginPrompt = 'Please enter your login email address';
  // memorableQuestion = 'Memorable question';
  // memorableAnswer = '';
  // newPassword = '';
  // confirmPassword = '';

  loginEmailAddress = '';
  urlRoot = '';
  resetPasswordRequestVM: PasswordResetRequestViewModel;
  sendingStatus = false;

  constructor(private authenticationService: AuthenticationService, private router: Router) {}

  ngOnInit(): void {
    this.urlRoot = window.location.origin;
    this.sendingStatus = false;
  }

  onSendResetLinkClick() {
    if (this.sendingStatus) {
      return;
    }
    console.log('Reset password code');
    console.log(this.loginEmailAddress);
    this.resetPasswordRequestVM = new PasswordResetRequestViewModel();
    this.resetPasswordRequestVM.username = this.loginEmailAddress;
    this.resetPasswordRequestVM.origin = this.urlRoot;
    this.sendingStatus = true;
    this.authenticationService
      .requestPasswordReset(this.resetPasswordRequestVM)
      .subscribe((res) => {
        if (res) {
          console.log('Password reset link has been sent');
          this.sendingStatus = false;
          this.router.navigateByUrl('password-request-confirmation');
        }
      });
  }
}
